export default (getText: (key: string, category: string) => string) => (key: string) =>
  ({
    title: getText('Raw Information', 'Patient_Details_Tabs_Summary_Form_RawInfos'),
    closeBtnLabel: getText('Close', 'Patient_Details_Tabs_Summary_Form_RawInfos'),
    copyBtnOn: getText('Copied!', 'Patient_Details_Tabs_Summary_Form_RawInfos'),
    copyBtnOff: getText('Copy summary', 'Patient_Details_Tabs_Summary_Form_RawInfos'),
    questionSkipped: getText('Skipped', 'Patient_Details_Tabs_Summary_Form_RawInfos'),
    emergencyCalled: getText('Called', 'Patient_Details_Tabs_Summary_Form_RawInfos'),
  }[key])
